import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DatasetMarkdownPanelAll from './DatasetMarkdownPanelAll';

const DatasetMarkdownPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DatasetMarkdownPanelAll, narrow: DatasetMarkdownPanelAll }}
  />
);

export default DatasetMarkdownPanel;
